import { FormattedMessage, useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework";

import { formatRegisteredSymbol } from "./utils";

const EnterpriseSoftwareDevelopment = () => {
    const intl = useIntl();
    return (
        <TabsContent
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.supercharge",
                        defaultMessage: "Supercharge dev productivity"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.supercharge.bodytext",
                        defaultMessage:
                            "Reduce bottlenecks and keep your software teams in the flow with everything you need to discover, plan, build, and operate world-class software."
                    })
                },
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.eliminateSilos",
                        defaultMessage: "Eliminate knowledge silos"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.eliminateSilos.bodyText",
                        defaultMessage:
                            "Create better harmony between software and business teams by keeping work visible across your entire organization."
                    })
                },
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.accelerateDevops.driveBetterOutcomes",
                        defaultMessage: "Drive better business outcomes"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.accelerateDevops.driveBetterOutcomes.bodyText",
                        defaultMessage:
                            "Connect and visualize data from all of your Atlassian and third-party tools to make faster and more informed decisions."
                    })
                }
            ]}
            contentLink={{
                linkText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.learnMore",
                    defaultMessage: "Learn about software development"
                }),
                link: useLocalizedHref("/teams/software-development"),
                linkLabel: "Learn about software development",
                productKey: "enterprise"
            }}
            pictureProps={{
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5kq1t5b8yd8rfi6b617314esnw1mt5ra.webp",
                    alt: "",
                    width: 1544,
                    height: 1092
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "EnterpriseLandingPage.tab.softwareDevelopment.resources",
                defaultMessage: "Software development resources"
            })}
            cardsContent={[
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps",
                        defaultMessage: "Solutions"
                    }),
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps.headerText",
                        defaultMessage:
                            "Open DevOps: Keep your tools, ditch the setup"
                    }),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps.linkText",
                            defaultMessage: "Learn more"
                        }),
                        href: useLocalizedHref("/solutions/devops"),
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Learn more"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-01-solutions@2x-310314428.webp",
                            alt: ""
                        }
                    }
                },
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant",
                        defaultMessage: "Report"
                    }),
                    headerText: (
                        <FormattedMessage
                            id="EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant.headerText"
                            defaultMessage="Atlassian named a Leader in the 2024 Gartner<sup>®</sup> Magic Quadrant™ for DevOps Platforms"
                            values={formatRegisteredSymbol}
                        />
                    ),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant.linkText",
                            defaultMessage: "Read report"
                        }),
                        href: useLocalizedHref(
                            "/gartner/magic-quadrant-devops"
                        ),
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Read report"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-01-report@2x-1971220130.webp",
                            alt: ""
                        }
                    }
                },
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo",
                        defaultMessage: "Demo"
                    }),
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo.headerText",
                        defaultMessage: "Maximize Developer Experience Demo"
                    }),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo.linkText",
                            defaultMessage: "Watch on-demand"
                        }),
                        href: useLocalizedHref(
                            "/webinars/enterprise-cloud/Maximize-Developer-Experience-with-Atlassian"
                        ),
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Watch on-demand"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-03-demo@2x-531224759.webp",
                            alt: ""
                        }
                    }
                }
            ]}
        />
    );
};

export { EnterpriseSoftwareDevelopment };
